import { jsx as _jsx } from "react/jsx-runtime";
import { AnimatePresence, motion } from 'framer-motion';
import { PromptComposer } from '../components/PromptComposer';
// Landing state for the /assistant surface: the composer to start a new chat.
// The explore rail + breadcrumb handling live in AssistantLayout.
export default function Assistant() {
    return /*#__PURE__*/ _jsx("div", {
        className: "flex flex-col h-full bg-background",
        children: /*#__PURE__*/ _jsx(AnimatePresence, {
            mode: "wait",
            children: /*#__PURE__*/ _jsx(motion.div, {
                initial: {
                    opacity: 0
                },
                animate: {
                    opacity: 1
                },
                exit: {
                    opacity: 0
                },
                transition: {
                    duration: 0.3
                },
                className: "flex flex-col flex-1",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "flex-1 overflow-y-auto flex items-center justify-center",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "w-full max-w-[860px] px-8 py-8",
                        children: /*#__PURE__*/ _jsx(PromptComposer, {})
                    })
                })
            }, "composer")
        })
    });
}
